export default {
  AddTicketMessage: 'افزودن پیام کاربر',
  Attachment: 'پیوست',
  Attachments: 'پیوست ها',
  Contents: 'محتوا',
  Department: 'دپارتمان',
  Email: 'ایمیل',
  Messages: 'پیام ها',
  Mobile: 'موبایل',
  Name: 'نام',
  Priority: 'اولویت',
  Respond: 'پاسخ دادن',
  respondContact: 'پاسخ به تماس',
  Responder: 'پاسخ دهنده',
  State: 'وضعیت',
  Title: 'عنوان',
  Ticket: 'تیکت',
  User: 'کاربر',
  creationTime: 'زمان ثبت تماس',
  Responder_s: 'پاسخ دهنده (ها)',

  areYouSureYouWantToDeleteThisContact: 'آیا از حذف این تماس اطمینان دارید؟',
  contactResponseSuccessfullyRegistered: 'پاسخ تماس با موفقیت ثبت شد',
  ticketResponseSuccessfullyRegistered: 'پاسخ تیکت با موفقیت ثبت شد',
  tickets: 'تیکت ها',
  priority: 'اولویت',
  department: 'دپارتمان',
  attachments: 'پیوست ها',
  contents: 'محتوا',
  clientType: 'نوع کلاینت',
  ticketWasClosedSuccessfuly: 'تیکت با موفقیت بسته شد',
  ticketWasOpenedSuccessfuly: 'تیکت با موفقیت باز شد'
}
